/**
 * Triggers a one-row CSV download in the browser (header line only, for the
 * user import template). Fixed four-column bilingual header accepted by the
 * backend: Courriel, Prénom, Nom de famille, Rôle.
 * The Rôle column is optional — unrecognised values fall back to the client default.
 */
export function downloadUserImportTemplateCsv() {
  const headerRow = "Courriel,Prénom,Nom de famille,Rôle";
  const blob = new Blob([`${headerRow}\n`], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'users-import-template.csv';
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
